import { render, staticRenderFns } from "./EmailClient.vue?vue&type=template&id=3a666f16&scoped=true"
import script from "./EmailClient.vue?vue&type=script&lang=ts"
export * from "./EmailClient.vue?vue&type=script&lang=ts"
import style0 from "./EmailClient.vue?vue&type=style&index=0&id=3a666f16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a666f16",
  null
  
)

export default component.exports